import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { FclLoginService } from 'src/app/services/fcllogin.service';
import { User, UserCustomers, Error } from 'src/app/model/user';

import { CustomerService } from 'src/app/services/customer.service';
import { Customers } from 'src/app/model/customer';
import { concatMap, catchError } from 'rxjs/operators';
import { throwError, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  registrationFormGroup: FormGroup;
  titleAlert = 'This field is required';
  requiredMessage = 'This field is required';
  displaySuccessModel = false;
  displayFailureNotification = false;
  displayErrorNotification = false;
  errorMessage = '';
  user: User;
  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private fclLoginService: FclLoginService,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    const loggedInUser: User = this.fclLoginService.getUser();
    this.user = JSON.parse(JSON.stringify(loggedInUser));
    this.user.createdBy = loggedInUser.loginId;
    this.createForm();
  }

  createForm() {
    this.registrationFormGroup = this.formBuilder.group({
      type: ['C', Validators.required],
      companyId: ['', Validators.required]
    });
  }

  get companyId() {
    return this.registrationFormGroup.get('companyId') as FormControl;
  }

  get type() {
    return this.registrationFormGroup.get('type') as FormControl;
  }

  onCancel() {
    this.router.navigate(['/']);
  }

  onSubmit() {

    this.registrationFormGroup.markAllAsTouched();
    const registrationForm = this.registrationFormGroup;
    if (registrationForm.status === 'VALID') {
      const companyId = this.companyId.value;

      const type = this.type.value;

      this.user.type = type;
      let customer = new Customers();
      customer.customerCode = this.companyId.value;
      this.customerService.getCustomerSummary('0', '5', customer, 'details').
        pipe(
          concatMap((data) => {
            if (data.customers && data.customers.length === 1) {
              customer = data.customers[0];
              this.setUser(customer);
              return this.fclLoginService.registerUser(this.user);
            } else if (data.customers && data.customers.length > 1) {

              const error = new Error();
              error.code = '0000';
              error.description = 'Multiple Customers found';

              const erorUser = new User();
              erorUser.success = false;
              erorUser.errors.push(error);
              return of(erorUser);

            } else {

              const error = new Error();
              error.code = '0000';
              error.description = 'No Companies found';

              const erorUser = new User();
              erorUser.success = false;
              erorUser.errors.push(error);
              return of(erorUser);
            }
          }),
          catchError(err => throwError(err))
        ).subscribe(responseObj => {
          if (responseObj.success) {
            this.displaySuccessModel = true;
            this.displayFailureNotification = false;
            this.displayErrorNotification = false;
          } else {
            const errors: Error[] = responseObj.errors;
            if (errors !== undefined && errors.length > 0) {
              this.displaySuccessModel = false;
              this.displayFailureNotification = false;
              this.errorMessage = errors[0].description;
              this.displayErrorNotification = true;
            }
          }
        }, error => {
          this.displaySuccessModel = false;
          this.displayFailureNotification = true;
          this.displayErrorNotification = false;
        });

    }

  }

  setUser(customer: Customers) {
    const userCustomers: UserCustomers = new UserCustomers();
    userCustomers.custId = customer.customerId;
    userCustomers.custCode = customer.customerCode;
    userCustomers.custName = customer.customerName;

    /*if (customer.businessUnits && customer.businessUnits.length > 0) {
      const userBusinessUnits: BusinessUnits[] = [];
      const busArray = customer.businessUnits;
      busArray.forEach((custbu) => {
        const bu = new BusinessUnits();
        bu.businessUnitCode = custbu.businessUnitCode;
        bu.businessUnitName = custbu.businessUnitName;
        userBusinessUnits.push(bu);
      });
      userCustomers.businessUnits = userBusinessUnits;
    }
    */
    this.user.userCustomers.push(userCustomers);
  }

  handleCloseEventForSuccess() {
    this.displaySuccessModel = false;
    this.displayFailureNotification = false;
    this.displayErrorNotification = false;
  }

  handleCloseErrorEvent() {
    this.displaySuccessModel = false;
    this.displayFailureNotification = false;
    this.displayErrorNotification = false;
  }

}
